import LightGallery from 'lightgallery/react';

// import styles
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import 'lightgallery/css/lg-autoplay.css';
import 'lightgallery/css/lg-fullscreen.css';
import 'lightgallery/css/lg-rotate.css';


import Img1 from '../../GallerieBilder/IMG_6016.JPG'
import Img2 from '../../GallerieBilder/IMG_6044.JPG'
import Img3 from '../../GallerieBilder/IMG_7479.JPG'
import Img4 from '../../GallerieBilder/IMG_7519.JPG'
import Img5 from '../../GallerieBilder/IMG_7524.JPG'
import Img6 from '../../GallerieBilder/IMG_7513.JPG'
import Img7 from '../../GallerieBilder/IMG_7686.JPG'
import Img8 from '../../GallerieBilder/IMG_7704.JPG'
import Img9 from '../../GallerieBilder/IMG_7776.JPG'
import Img10 from '../../GallerieBilder/Hirrlingen1.JPG'
import Img11 from '../../GallerieBilder/Hirrlingen2.JPG'
import Img12 from '../../GallerieBilder/Hirrlingen3.JPG'
import Img13 from '../../GallerieBilder/Hirrlingen6.JPG'
import Img14 from '../../GallerieBilder/Hirrlingen5.JPG'

// import plugins if you need
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import lgAutoplay from 'lightgallery/plugins/autoplay'
import lgFullscreen from 'lightgallery/plugins/fullscreen';
import lgRotate from 'lightgallery/plugins/rotate';

import './Gallerie.css'

const images = [
    { src: Img1 , alt: "" },
    { src: Img2, alt: "" },
    { src: Img3, alt: "" },
    { src: Img4, alt: "", },
    { src: Img5, alt: "", },
    { src: Img6, alt: "", },
    { src: Img7, alt: "", },
    { src: Img8, alt: "", },
    { src: Img9, alt: "", },
    { src: Img10, alt: "", },
    { src: Img11, alt: "", },
    { src: Img12, alt: "", },
    { src: Img13, alt: "", },
    { src: Img14, alt: "", },
]

export default function GalleryG() {
    const onInit = () => {
        console.log('lightGallery has been initialized');
    };
    return (
        
        <div className="Gallerie">
            <div className="header" style={{padding:"60px 0", display:"flex", flexDirection:"column", justifyContent:"center", background:"#940000"}}/>
            <LightGallery
                onInit={onInit}
                speed={500}
                download= {false}
                plugins={[lgThumbnail, lgZoom, lgAutoplay, lgFullscreen, lgRotate]}
            >

                {images.map((image, index) => {
                    return (
                        <a href={image.src} key={index}>
                            <img alt={image.alt} src={image.src} />
                        </a>
                    )
                })}
            </LightGallery>
        </div>
    );
}